function sliderCursor(){
    var owl = $('.owl-carousel');
    
    owl.each(function(){
        var owl_element = $(this);
        
        if (!owl_element.hasClass('olw-cursors')){
            owl_element.addClass('olw-cursors');

            $('<a class="gallery-cursor cursor-prev" aria-label="Previous" href="javascript:;"></a>').prependTo(owl_element.parents('.owl-carousel-wrapper'));
            $('<a class="gallery-cursor cursor-next" aria-label="Next" href="javascript:;"></a>').appendTo(owl_element.parents('.owl-carousel-wrapper'));
            
            owl_element.owlCarousel();

            // disable cursors
            owl_element.on('initialized.owl.carousel changed.owl.carousel refreshed.owl.carousel', function (event) {
                if (!event.namespace) return;
                var carousel = event.relatedTarget,
                    element = event.target,
                    current = carousel.current();
                    
                $('.gallery-cursor.cursor-next', element).toggleClass('disabled', current === carousel.maximum());
                $('.gallery-cursor.cursor-prev', element).toggleClass('disabled', current === carousel.minimum());
            });
            // Go to the next item
            $('.gallery-cursor.cursor-prev').on('click', function () {
                owl_element.trigger('prev.owl.carousel');
            });
            // Go to the previous item
            $('.gallery-cursor.cursor-next').on('click', function () {
                owl_element.trigger('next.owl.carousel');
            });
        }
    });
}

function appearEffect() {
    if ($('.heading-line').length > 0) {
        $('.heading-line').each(function (i, el) {
            var watcher = scrollMonitor.create(el);
            watcher.fullyEnterViewport(function () {
                $(el).addClass('line-visible');

                watcher.destroy();
            });
        });
    }
    if ($('.pattern-animation').length > 0) {
        $('.pattern-animation').each(function (i, el) {
            var watcher = scrollMonitor.create(el);
            watcher.fullyEnterViewport(function () {
                $(el).addClass('pattern-visible');

                watcher.destroy();
            });
        });
    }
}

function initGallModal() {
    if ($('html').hasClass('touch')) return false;

    if (document.querySelector('.gallery-item')){
        var showPhotosCtrl = document.querySelector('#masthead .menu-btn-container.btn'),
            items = [],
            currentItem,
            looptimeout,
            mousetime;

        Array.from(document.querySelectorAll('.gallery-item')).forEach(item => items.push(item));

        if (document.querySelector('#masthead .menu-btn-container.btn')) {
            // Mouseenter: Start looping through the photos that are inside the viewport.
            // We only loop through these so that we can see the whole animation (photo scaling down to its grid position)
            showPhotosCtrl.addEventListener('mouseenter', () => {
                $('.menu-wrapper .navbar .menu-container').addClass('background-transparent');

                TweenLite.to(['.logo-container', '.mmb-container'], 0.8, {
                    autoAlpha: 0,
                    ease: Power2.easeOut,
                });
                TweenLite.to('.modalGallery', 1, {
                    autoAlpha: 1,
                    ease: Power2.easeOut,
                });

                clearTimeout(mousetime);
                currentItem = null;
                mousetime = setTimeout(() => loopThroughPhotos(), 40);
            });
            // Mouseleave: stop the photo looping animation.
            showPhotosCtrl.addEventListener('mouseleave', () => {
                TweenLite.to('.modalGallery', 1, {
                    autoAlpha: 0,
                    ease: Power2.easeOut,
                });
                TweenLite.to(['.logo-container', '.mmb-container'], 1.2, {
                    autoAlpha: 1,
                    ease: Power2.easeOut,
                });

                $('.menu-wrapper .navbar .menu-container').removeClass('background-transparent');

                clearTimeout(mousetime);
                stopLoop();
            });
        }
    }
    // Looping the grid photos.
    function loopThroughPhotos() {
        const loopInterval = 350;
        if (items.length > 1) {

            let oldpos = -1;
            const loop = (pos = 0) => {
                // Cache the previous item.
                if (oldpos >= 0) {
                    const oldel = items[oldpos];
                    // Reset.
                    TweenLite.set(oldel, {
                        opacity: 0,
                        zIndex: 1
                    });
                }

                currentItem = items[pos];
                
                // Fade in current visible item for the first iteration in the loop.
                if (oldpos === -1) {
                    TweenLite.set(currentItem, {
                        zIndex: 998
                    });

                    TweenLite.to(currentItem, .2, {
                        autoAlpha: 1,
                        ease: Power2.easeOut,
                    });
                    
                } else {
                    TweenLite.set(currentItem, {
                        autoAlpha: 1,
                        zIndex: 998
                    });
                }

                oldpos = pos;
                pos = pos < items.length - 1 ? pos + 1 : 0;
                looptimeout = setTimeout(() => loop(pos), loopInterval);
            };
            loop();
        }
    }
    function stopLoop() {
        // Stop the loop.
        clearTimeout(looptimeout);

        for (let item of items) {
            if (item == currentItem) {
                // Fade out current visible item.
                TweenLite.to(item, .2, {
                    autoAlpha: 0,
                    ease: Power2.easeOut,
                    onComplete: function () {
                        TweenLite.set(item, { x: 0, y: 0, scale: 1 });
                    }
                });
            } else {
                // Reset.
                TweenLite.set(item, { opacity: 0, x: 0, y: 0, scale: 1 });
            }
        }
    }
}

$(window).on('load', function () {
    $(window).resized(function () {
        var alt_menu = $('#masthead > div').outerHeight();
        $('.menu-wrapper').height(alt_menu);
    });
});

function customScripts(){
    /*HELPERS*/
    var templateUrl = directory_uri.stylesheet_directory_uri;

    appearEffect();
    initGallModal();

    initMiewEstagios();
    initMiewFormacoes();
    initMiewGrid();
    initMiewParceiros();
    heroParralax();
    initMiewSlider();

    var hoverIn,
        hoverOut;

    $('.noticias_grid .noticias_divs figcaption, .posts-divs figcaption').on('mouseenter', function () {
        var $this = $(this);
        clearTimeout(hoverIn, hoverOut);
        hoverIn = setTimeout(function () {
            $this.addClass('hover');
        }, 700);
    }).on('mouseleave', function () {
        clearTimeout(hoverIn, hoverOut);

        var $this = $(this);
        hoverOut = setTimeout(function () {
            $this.removeClass('hover');
        }, 700);
    });

    if ($('.formacoes_table').length>0){
        $('<a href="javascript:;" class="fa fa-plus"></a>').appendTo('.formacoes_table tr:eq(0) td:eq(1)');
        $('.formacoes_table .fa-plus').on('click', function(){
            $('.formacoes_table tr:not(.vc-th)').fadeToggle();
        });
    }

    if ($('.slick-relacionados').length > 0) {
        initRelacionados();

        $(window).resize(function (e) {
            initRelacionados();
        });

        function initRelacionados() {
            if ($('body').innerWidth() <= 960) {
                if (!$('.slick-relacionados').hasClass('slick-initialized')) {
                    $('.slick-relacionados').slick({
                        dots: false,
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        arrows: true,
                        appendArrows: '.relacionados_grid',
                        cursors: false,
                        infinite: false,
                        adaptiveHeight: false,
                        autoplaySpeed: 8000,
                        responsive: [
                            {
                                breakpoint: 640,
                                settings: {
                                    slidesToShow: 1,
                                    slidesToScroll: 1
                                }
                            }
                        ]
                    });
                }
            } else {
                if ($('.slick-relacionados').hasClass('slick-initialized')) $('.slick-relacionados').slick('unslick');
            }
        }
    }

    if ($('.slick-posts').length > 0) {
        initMural();

        $(window).resize(function (e) {
            initMural();
        });

        function initMural() {
            if ($('body').innerWidth() > 960) {
                if (!$('.slick-posts').hasClass('slick-initialized')) {
                    $('.slick-posts').slick({
                        dots: false,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                        cursors: false,
                        infinite: false,
                        adaptiveHeight: false,
                        autoplay: true,
                        autoplaySpeed: 5000,
                    });
                    $('.slick-posts').slick('slickFilter', '.' + $('#month_indicator').data('current'));
                }
            } else {
                $('.posts-divs').css('display', 'none');
                $('.posts-divs.' + $('#month_indicator').data('current')).fadeIn('slow');

                if ($('.slick-posts').hasClass('slick-initialized'))$('.slick-posts').slick('unslick');
            }
        }
    }
  

    $('.main-header, .menu-side-content').appendTo('.menu-wrapper');
    var $elemMenu = $('[class^="light-"], [class^="-light"], [class*=" light-"], [class*="-light"]', '.masthead-vertical');
    if ($elemMenu.length > 0) {
        $elemMenu.each(function () {
            if (!$(this).hasClass('logo-image')) {
                var str = $(this).attr("class");
                str = str.replace(new RegExp('light', 'g'), 'dark');

                $(this).attr("class", str);
            }
        });
        
        if($('body').hasClass('error404')){
            var $elements = $('[class^="light-"], [class^="-light"], [class*=" light-"], [class*="-light"]');
            $('#main-logo svg').addClass('light');

            $elements.each(function() {
                if (!$(this).hasClass('logo-image')){
                    var str = $(this).attr("class");
                    str = str.replace(new RegExp('light', 'g'), 'dark');

                    $(this).attr("class", str); 
                }
            });
        }
    }
}